export default __webpack_public_path__ + "static/media/reachad-black.256c0111.jpeg";